<template>
  <el-dialog
    v-if="visible"
    center
    title="请选择举报理由"
    width="600px"
    append-to-body
    :visible.sync="visible"
    :before-close="(_) => $emit('visible', false)"
  >
    <div class="report">
      <div class="report-item" v-for="item in reportCase">
        <div class="title">{{ item.title }}</div>
        <div class="children-box">
          <div
            class="children-item"
            v-for="child in item.children"
            @click="handleRadio(child)"
          >
            <div
              class="radio"
              :class="{ select: reportIds.includes(child.id) }"
            >
              <i v-if="reportIds.includes(child.id)" class="el-icon-check"></i>
            </div>
            <div class="label">{{ child.title }}</div>
          </div>
        </div>
      </div>
      <textarea
        v-if="reportIds.includes('other')"
        v-model="reportContent"
        class="report-content"
        placeholder="请输入填写举报内容（必填）"
      ></textarea>
    </div>
    <div slot="footer" class="report-footer">
      <el-button @click="$emit('visible', false)">取 消</el-button>
      <el-button style="background-color: #0054f7; color: white" @click="report"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { ReportService } from "@/common/service";

export default {
  name: "Report",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
    },
    type: {
      type: Number,
    },
  },
  model: {
    prop: "visible",
    event: "visible",
  },
  data() {
    return {
      reportIds: [],
      reportContent: "",
    };
  },
  computed: {
    reportCase() {
      return this.$store.state.report.reportCase;
    },
  },
  methods: {
    // 点击举报项目
    handleRadio(item) {
      this.reportIds.indexOf(item.id) == -1
        ? this.reportIds.push(item.id)
        : this.reportIds.splice(this.reportIds.indexOf(item.id), 1);
    },
    // 举报
    report() {
      if (!this.reportIds.filter((item) => item != "other").length)
        return this.$message.error("请选择举报类目");
      if (this.reportIds.includes("other") && !this.reportContent)
        return this.$message.error("请填写举报内容");
      let report_id = 0;
      switch (this.type) {
        case 1:
          report_id = this.info.video_id;
          break;
        case 4:
          report_id = this.info.datum_id;
          break;
        case 5:
          report_id = this.info.article_id;
          break;
        default:
          report_id = this.info.id;
      }
      let params = {
        report_id,
        type: this.type,
        case_ids: this.reportIds.filter((item) => item != "other").join(","),
        content: this.reportIds.includes("other") ? this.reportContent : "",
      };
      ReportService.userReport(params).then(({ msg, data }) => {
        this.$message.success(msg);
        this.$emit("visible", false);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  z-index: 9999;
}
::v-deep .el-dialog__header .el-dialog__title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
}
::v-deep .el-dialog__body {
  padding-top: 5px;
}
.report {
  padding: 20px 0 50px;
  width: 100%;
  border-top: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;
  .report-item {
    margin-bottom: 40px;
    .title {
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 20px;
    }
    .children-box {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .children-item {
        display: flex;
        align-items: center;
        width: 25%;
        .radio {
          width: 16px;
          height: 16px;
          border: 1px solid #979797;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .select {
          border-color: transparent;
          background-color: #2a63f3;
        }
        .label {
          font-size: 16px;
          font-weight: 400;
          color: #222222;
          height: 16px;
          line-height: 16px;
          margin-left: 5px;
        }
      }
    }
  }
  .report-content {
    width: 100%;
    height: 120px;
    padding: 15px 10px;
    background: #f5f5f5;
    border-radius: 10px;
    border: none;
    outline: none;
    resize: none;
    box-sizing: border-box;
    font-size: 14px;

    ::placeholder {
      font-size: 16px;
      font-weight: 400;
      color: #666666;
    }
  }
}
.report-footer {
  .el-button {
    width: 120px;
    height: 40px;
  }
}
</style>
